import React from 'react';
import { graphql, PageProps, navigate } from 'gatsby';

import GlobalLayout from '@layouts/GlobalLayout/GlobalLayout';
import { HeadTags } from '@layouts/HeadTags/HeadTags';
import { Button } from '@assets/components/Button/Button';

import './career-details.scss';
interface SiteInfoData {
  markdownRemark: {
    html: string;
    frontmatter: {
      position: string;
      schedule: string;
      salary: string;
      location: string;
      department: string;
      slug: string;
    };
  };
}

type CareerDetailsProps = PageProps<SiteInfoData>;

export default function CareerDetails({ data }: CareerDetailsProps) {
  const { html } = data.markdownRemark;
  const { department, location, position, salary, schedule } =
    data.markdownRemark.frontmatter;

  return (
    <GlobalLayout>
      <article className="betterMood__careerDetails">
        <Button secondary onClick={() => navigate(-1)}>
          <svg
            stroke="currentColor"
            fill="none"
            strokeWidth="2"
            viewBox="0 0 24 24"
            aria-hidden="true"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 19l-7-7 7-7"></path>
          </svg>
          <span>Back</span>
        </Button>
        <section className="betterMood__careerDetails-container">
          <h1>{position}</h1>
          <p className="betterMood__careerDetails-summary">
            {department} &bull; {location} &bull; {schedule} &bull; {salary}
          </p>
          <div dangerouslySetInnerHTML={{ __html: html }} />
          <Button
            href="https://ybpts9s2v8k.typeform.com/to/UzfS8kXN"
            primary
            pill>
            Apply for this position
          </Button>
        </section>
      </article>
    </GlobalLayout>
  );
}

export const Head = () => (
  <>
    <HeadTags
      title="Open Position Listing"
      description="Join our dynamic team at Better Mood! Explore exciting career opportunities, work with innovative professionals, and make a difference in the world of mental health. Apply today!"
    />
  </>
);

export const query = graphql`
  query CareerPositions($slug: String) {
    markdownRemark(
      frontmatter: { slug: { eq: $slug }, page: { eq: "careers" } }
    ) {
      html
      frontmatter {
        department
        location
        position
        salary
        schedule
      }
    }
  }
`;
